/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { axiosInstance, isEmptyData } from '../utils/helper';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

const useMerchant = () => {
	const history = useHistory();

	const queryParams = new URLSearchParams(window.location.search);
	const merchantCode = queryParams.get('merchantCode');
	const latitude = queryParams.get('latitude');
	const longitude = queryParams.get('longitude');
	const [isLoading, setIsLoading] = useState(true);

	const handleGetStoreDetail = async (merchantCode, latitude, longitude) => {
		console.log('handleGetStoreDetail', merchantCode);

		try {
			setIsLoading(true);

			let url = `store/detailStoreByMerchantCode?merchantcode=${merchantCode}`;

			if (latitude && longitude) {
				url += `&latitude=${latitude}&longitude=${longitude}`;
			}
			const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
				},
			});

			setIsLoading(false);

			if (res.data?.status === 'ok') {
				const data = res.data?.result;
				//call api to get store detail
				if (data?.storeOpen === '1') {
					history.push({
						pathname: `/outlet/${data?.storeSlug}/delivery`,
						state: {
							storeID: data?.storeID,
							storeSlug: data?.storeSlug,
							storeName: data?.storeName,
							storeImage: data?.storeImage,
							rating: data?.rating,
							bannerImage: data?.storeBannerImage,
						},
					});
				}
			}
		} catch (error) {
			setIsLoading(false);
			console.log('error: ', error);
		}
	};

	useEffect(() => {
		if (isEmptyData(merchantCode)) return;
		handleGetStoreDetail(merchantCode, latitude, longitude);
	}, [merchantCode, latitude, longitude]);

	useEffect(() => {
		if (isEmptyData(merchantCode)) {
			return setIsLoading(false);
		}
	}, []);

	return { isLoading };
};

export default useMerchant;
